/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_7Inputs */

const vi_irrigation_weekday_7 = /** @type {(inputs: Irrigation_Weekday_7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CN`)
};

/**

* @param {Irrigation_Weekday_7Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_7 = /** @type {((inputs?: Irrigation_Weekday_7Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_7Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_7(inputs)
});